export default __webpack_public_path__ + "static/appscreenshots_2-e6703a752c6beff9148fb33964523139.png";